import { createContext, useContext, useEffect, useState } from "react";
import { useGeneralSetting } from "./GeneralSettingContext";
import { downloadData } from 'aws-amplify/storage';

const Context = createContext({});

export default function GeoCoordinateProvider({ children }) {
  const { generalSetting } = useGeneralSetting();
  const [wardBoundary, setWardBoundary] = useState(null);
  const [emergencyRoutes, setEmergencyRoutes] = useState(null);

  const retrieveCoordinateBoundary = async () => {
    try {
      const { body } = await downloadData({ key: 'setting/ward_boundaries.json' }).result;
      const setting = JSON.parse(await body.text());
      if (!setting) setWardBoundary(null);

      /**
       * Remove the first element which is 'City Boundary'
       */
      const newBorderSettings = generalSetting?.borderSettings?.slice(1);

      const data = newBorderSettings?.map((location) => {
        const locationId = location?.id;
        const color = location?.color;
        if (locationId && color) {
          if (setting && setting[locationId]) {
            return { data: setting[locationId], color };
          }
        }
        return null;
      });
      setWardBoundary(data);

    } catch (err) {
      setWardBoundary(null);
    }
  }

  const getEmergencyRoutes = async () => {
    try {
      const { body } = await downloadData({ key: 'setting/emergency_routes.json' }).result;
      const setting = JSON.parse(await body.text());
      setEmergencyRoutes(setting);
    }
    catch (e) {
      console.error("ERROR", e);
    }
  }

  useEffect(() => {
    retrieveCoordinateBoundary();
  }, [generalSetting]);

  useEffect(() => {
    getEmergencyRoutes();
  }, []);

  return (
    <Context.Provider value={{ wardBoundary, emergencyRoutes, setWardBoundary , setEmergencyRoutes }}>
      {children}
    </Context.Provider>
  );
}

export const useGeoCoordinate = () => useContext(Context);